import { LOAD_CART_REQUEST, LOAD_CART_SUCCESS, LOAD_CART_ERROR } from '../types';
import { forgetCart } from './forget-cart';
export const loadCartRequest = () => {
    return {
        type: LOAD_CART_REQUEST,
    };
};
export const loadCartSuccess = (cart) => {
    return {
        type: LOAD_CART_SUCCESS,
        data: cart,
    };
};
export const loadCartError = (error) => {
    return {
        type: LOAD_CART_ERROR,
        error: true,
        payload: error,
    };
};
export const loadCart = () => {
    return async (dispatch, getState, { chord }) => {
        const createOrLoadCart = async (cartData, authToken) => {
            // if there is no cart token or number stored in Redux/localStorage, create a new order
            if (!cartData.number)
                return chord.oms.createOrder(authToken);
            try {
                const cart = await chord.oms.getOrder(cartData);
                // if the cart token or number stored in Redux/localStorage has an order state of 'complete',
                // clear and create a new order confirm
                if (cart.state === 'complete') {
                    dispatch(forgetCart());
                    return chord.oms.createOrder(authToken);
                }
                return cart;
            }
            catch (error) {
                if (error.status !== 401)
                    throw error;
                // if the cart token or number stored in Redux/localStorage is invalid, clear and create a new order
                dispatch(forgetCart());
                return chord.oms.createOrder(authToken);
            }
        };
        try {
            const { cart, auth } = getState();
            dispatch(loadCartRequest());
            const newCart = await createOrLoadCart(cart.data, auth.token);
            dispatch(loadCartSuccess(newCart));
            return newCart;
        }
        catch (error) {
            dispatch(loadCartError(error));
            throw error;
        }
    };
};
